<template>
  <tm-popup
    v-model="popupVisible"
    position="bottom"
    round
    class="personnel-info-popup"
  >
    <!-- userId 获取个人信息时 loading 占位 -->
    <div
      v-if="loading || hasError"
      v-loading="loading"
      class="loading-placeholder shadow-lg flex justify-center items-center"
      style="height:220px"
    >
      <div v-if="hasError" class="teld-color-gray">加载失败</div>
    </div>

    <div
      v-else-if="record"
      class="
        content-wrapper rounded border-2 border-solid border-gray-100
        flex flex-col shadow-lg bg-white
      "
      style="min-height:180px"
    >
      <!-- 上部 -->
      <div class="flex p-3" style="">
        <user-avatar
          :image-url="record.Avatar"
          :class-list="['w-20 h-20']"
        ></user-avatar>

        <!-- 头像右侧主信息：姓名和公司 -->
        <div
          class="flex flex-col justify-center ml-4"
        >
          <div class="flex items-center">
            <span class="mr-2 text-base font-semibold flex items-center">
              {{ record.RealName }}
            </span>
            <span class="" style="line-height:0">
              <gender-male v-if="record.Gender === '男'" class="w-4 h-4" />
              <gender-female
                v-else-if="record.Gender === '女'"
                class="w-4 h-4"
              />
            </span>
          </div>

          <div class="teld-color-gray">{{ record.CompanyName }}&nbsp;</div>
        </div>
      </div>

      <!-- 下部 -->
      <div class="flex-1 teld-bg-color-gray">
        <div
          class="info-card max-h-60 bg-white py-3 px-5 rounded overflow-y-auto mt-1"
        >
          <div class="flex">
            <div class="teld-color-gray w-20">手机号</div>
            <span v-if="record._showFullMobile_">{{ record.Mobile }}</span>
            <span v-else class="flex-1 break-all">
              {{ record._mobileMask_ }}
              <span
                ref="viewMobileRef"
                class="ml-2 text-xs teld-theme-color cursor-pointer"
                @click.capture.prevent.stop="onClickMobileMask(record)"
              >
                查看
              </span>
            </span>
          </div>
          <div class="flex">
            <div class="teld-color-gray w-20">邮箱</div>
            <span class="flex-1 break-all">{{ record.Email || '无' }}</span>
          </div>
          <div class="flex">
            <div class="teld-color-gray w-20">账号</div>
            <span class="flex-1 break-all">{{ record.Account || '无' }}</span>
          </div>
          <div class="flex">
            <div class="teld-color-gray w-20">部门</div>
            <span class="flex-1 break-all">
              {{ joinDepartmentName(record) || '无' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </tm-popup>
</template>

<script>
// Components
import UserAvatar from '../../user-avatar.vue';
import GenderFemale from '../../svg-icons/gender-female.vue';
import GenderMale from '../../svg-icons/gender-male.vue';

// Utils
import { mobileMask } from '../../../core';
// import demoUserInfo from '../../../mock/userInfo.js';

const MARGIN_GAP = 12;

export default {
  name: 'PersonnelInfoPopup',
  props: {
    userId: {
      type: String,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    UserAvatar,
    GenderFemale,
    GenderMale,
  },
  data() {
    return {
      loading: true,
      hasError: false,
      record: null,
    };
  },
  watch: {
    userId(nVal) {
      this.init();
    },
  },
  computed: {
    popupVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit('update:visible', v);
      },
    },
  },
  methods: {
    init() {
      this.hasError = false;
      if (this.userId) {
        this.getUserInfo();
      }
    },
    // 只有 id 时从接口获取
    async getUserInfo() {
      this.loading = true;
      try {
        /**
         * 【WARNING】这个接口没有 state 那一层，直接 data
         */
        const { data } = await this.$utils.sgApi.getDataAsync({
          url: this.$utils.common.getServiceUrl('SYS_UserMgr_GetSysUserById '),
          data: { userId: JSON.stringify(this.userId) },
        });

        if (!data) {
          this.hasError = true;
          return;
        }

        // Mock
        // setTimeout(() => {
        //   this.record = demoUserInfo;
        //   this.loading = false;
        // }, 500);
        this.record = {
          ...data,
          _mobileMask_: mobileMask(data.Mobile),
          _showFullMobile_: false,
        };
      } catch (error) {
        console.log(error);
        this.hasError = true;
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }
    },
    joinDepartmentName(item) {
      const { DepartmentName, WorkgroupName } = item;
      const arr = [];
      DepartmentName && arr.push(DepartmentName);
      WorkgroupName && arr.push(WorkgroupName);
      return arr.join('-');
    },
    onClickMobileMask(item) {
      item._showFullMobile_ = true;
    },
    onClosed() {
      this.hasError = false;
      this.loading = false;
      this.record = null;
      this.$emit('update:user-id', null);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
